import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { HelpOutline } from '@mui/icons-material';
import { IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import type { AppStore } from '@/interfaces/service/appstore/appstore.interface';
import { useAppStoreStore } from '@/stores/appstore.store';
import { REVIEW_ROUTES } from '@/constants/path.constants';
import FlexBox from '@/components/FlexBox';
import StoreAuthHandler from '@/components/StoreAuthHandler';
import CustomMuiButton from '@/components/button/CustomMuiButton';
import ServiceGuideModalResolver from '@/views/appstore/dashboard/components/ServiceGuideModalResolver';

const DashboardHeader = ({ appStoreId, totalReviewCount }: { appStoreId: number; totalReviewCount: number }) => {
  const router = useRouter();
  const { appStores } = useAppStoreStore((state) => state);

  const [showServiceGuideModal, setShowServiceGuideModal] = useState(false);
  const [isAppStoreStable, setIsAppStoreStable] = useState(Object.values(appStores)[0]?.status === 'STABLE');
  const [currentAppStore, setCurrentAppStore] = useState<AppStore | null>(null);

  const isMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    const currentStore = Object.values(appStores)[0];
    if (currentStore) {
      setCurrentAppStore(currentStore);
    }
  }, []);

  useEffect(() => {
    const currentStatus = Object.values(appStores)[0]?.status;
    if (currentStatus) {
      setIsAppStoreStable(currentStatus === 'STABLE');
    }
  }, [appStores]);

  return (
    <Stack spacing={3}>
      <StoreAuthHandler currentAppStore={currentAppStore} totalReviewCount={totalReviewCount} isMobile={isMobile} />

      {totalReviewCount > 0 ? (
        <FlexBox
          style={{
            width: '100%',
            justifyContent: 'space-between',
            marginTop: '20px'
          }}
        >
          <FlexBox>
            <Typography variant="h4">리뷰 관리</Typography>
            <IconButton
              sx={{
                width: '30px',
                height: '30px',
                marginLeft: '4px',
                padding: 0
              }}
              onClick={() => setShowServiceGuideModal(!showServiceGuideModal)}
              aria-label="서비스 가이드 보기"
            >
              <HelpOutline color="primary" />
            </IconButton>
          </FlexBox>
          {currentAppStore && <CustomMuiButton type="SECONDARY" size={isMobile ? 'm' : 'l'} label="전체리뷰 보기" onClick={() => router.push(REVIEW_ROUTES.getReviews(currentAppStore.storeId))} />}
        </FlexBox>
      ) : null}

      <ServiceGuideModalResolver showModal={showServiceGuideModal} handleShowModal={() => setShowServiceGuideModal(!showServiceGuideModal)} modalKey="reviewService" />
    </Stack>
  );
};

export default DashboardHeader;
